import { CaseSchema, SwitchStepSchema } from '@feedyou-ai/feedbot-schema'

import { Search } from '../../../types'
import { createConfigs, searchMutableObject } from '../../../../../features/flowSearch'

export const search: Search<SwitchStepSchema> = (step, query) => {
  const directResults = searchMutableObject(
    step,
    query,
    { type: 'step', id: step.id },
    createConfigs({
      id: ['id'],
      text: ['title', 'expression', 'condition', 'conditionTitle']
    })
  )

  const allCases = [...(step.cases || []), ...(step.default ? [step.default] : [])]
  const caseResults = allCases.flatMap(switchCase => searchInSwitchCase(switchCase, query))

  return [...directResults, ...caseResults]
}

export function searchInSwitchCase(switchCase: CaseSchema, query: string) {
  return searchMutableObject(
    switchCase,
    query,
    { type: 'switch_case', id: switchCase.id ?? 'unknown' },
    createConfigs({
      id: ['id'],
      dialog: ['dialog'],
      text: ['title', 'value', 'condition']
    })
  )
}
